import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  return <section className="py-10 bg-white" data-id="element-72">
      <div className="container mx-auto px-4" data-id="element-73">
        <div className="max-w-3xl mx-auto" data-id="element-74">
          <FadeIn data-id="element-75">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-6" data-id="element-76">
              Mientras tratás de conectar... los días pasan. 💔
            </h2>
          </FadeIn>

          <div className="space-y-3 mb-6" data-id="element-77">
            <FadeIn delay={0.1} direction="left" data-id="element-78">
              <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-79">
                <div className="text-3xl shrink-0" data-id="element-80">📱</div>
                <p className="text-base md:text-lg text-slate-700 pt-0.5" data-id="element-81">
                  Todo se vuelve pantallas, trabajo y cansancio.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} direction="left" data-id="element-82">
              <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-2xl border border-slate-100" data-id="element-83">
                <div className="text-3xl shrink-0" data-id="element-84">💤</div>
                <p className="text-base md:text-lg text-slate-700 pt-0.5" data-id="element-85">
                  Terminás el día sintiendo que no aprovechaste el tiempo
                  juntos.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} direction="left" data-id="element-86">
              <div className="flex items-start gap-4 p-4 bg-red-50 rounded-2xl border border-red-100" data-id="element-87">
                <div className="text-3xl shrink-0" data-id="element-88">⚠️</div>
                <p className="text-base md:text-lg text-slate-800 font-semibold pt-0.5" data-id="element-89">
                  Si no cambiás algo ahora, tus hijos crecerán con el recuerdo
                  de una tablet, no de un momento con vos.
                </p>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} data-id="element-90">
            <div className="text-center p-6 bg-brand-50 rounded-3xl border border-brand-100" data-id="element-91">
              <p className="text-lg md:text-xl text-brand-900 font-bold italic" data-id="element-92">
                "No es falta de amor, es que la rutina te roba el tiempo.
                Nosotros te devolvemos la brújula."
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}